module.exports = __webpack_public_path__ + "static/media/powerteam.f69dd882.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/standart/powerteam.png
// module id = 813
// module chunks = 20